import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

import { getContentLocaleUrl } from './getContentLocaleUrl';

type Props = {
  content: CmsApiPage;
};

export function getContentPageUrl({ content }: Props) {
  const contentLocaleUrl = getContentLocaleUrl({ content });
  return contentLocaleUrl[content.locale];
}
